import http from '@/services/http'
import { userUrl } from '@/services/url'
import type { ShipmentInfoDTO, StoreListResponse } from './stores'

export interface UpdateStoreInfoDTO {
  language?: string
  /** 店铺id */
  storeId: string
  /** 来源（销售平台） */
  source: string
  /** 店铺名称 */
  storeName: string

  storeInfoId: string
  /** 寄方信息 */
  storeShipmentInfo?: ShipmentInfoDTO & {
    language?: string
  }
  /**销售平台邮件开关*/
  platformEmailSwitch?: 0 | 1
}

/**
 * 店铺解绑: http://api-doc-sl.inshopline.com/#/project/80/feature%2F20220727_1187_shipment_info/interface/59b3f0e5d4a47b24c866274fbad784e2
 * @param data
 * @returns
 */
export const unBindApi = async (data: { storeId: string; source: string }) => await http.admin.post(userUrl.unbind, data)

/**
 * 店铺绑定: http://api-doc-sl.inshopline.com/#/project/80/feature%2F20211109_mvp2/interface/67497196998acbfee67ada07e38a5bea
 * @param data
 * @returns
 */
//TODO: 重复接口定义
export const bindApi = async (data: { code: string; source: string; redirectUri?: string; storeId?: string }) => await http.admin.post(userUrl.bind, data)

/**
 * 查询绑定的店铺列表: http://api-doc-sl.inshopline.com/#/project/80/feature%2F20220727_1187_shipment_info/interface/7d4d4832e19d4d890fd0b7f5fb00fc51
 * @returns
 */
export const checkBindStoreList = async () => await http.admin.get<StoreListResponse>(userUrl.bindStoreList)
interface CheckBindApiParams {
  source: string
  storeId: string
}

/**
 * 检查绑定状态: http://api-doc-sl.inshopline.com/#/project/80/feature%2F20220727_1187_shipment_info/interface/c485c49f7770c44d5924444304a5374d
 * @param data
 * @returns
 */
export const checkBindApi = async (data: CheckBindApiParams) =>
  await http.admin.post<{
    status: string
  }>(userUrl.checkBind, data)

/**
 * 更新店铺信息: http://api-doc-sl.inshopline.com/#/project/80/feature%2F20220727_1187_shipment_info/interface/ae83df8e802a6fbccac97e777c598e98
 * @param data
 */
export const updateStoreInfo = async (data: UpdateStoreInfoDTO) => await http.admin.post(userUrl.updateStoreInfo, data)

export interface IStoreInfo {
  /**店铺来源
 Shopline SHOPEE */
  source: string
  /**Oauth标准需要回调的url，仅用于传值 */
  redirectUri: string

  storeId?: string
  storeCountry?: string
}
/** 获取授权url(虾皮等) */
export const getStoreAuthorizeUrl = async (data: IStoreInfo) =>
  await http.admin.post<{
    url: string
  }>(userUrl.getStoreAuthorizeUrl, data)

/** 未登陆时获取授权url(虾皮等) */
export const getStoreAuthorizeUrlWithoutLogin = async (data: IStoreInfo) =>
  await http.admin.post<{
    url: string
  }>(userUrl.getStoreAuthorizeUrlWithoutLogin, data)

export interface IBindStoreInfo {
  /**认证code */
  code: string
  /**店铺来源
Shopline */
  source: string
  /**Oauth标准需要回调的url，仅用于传值 */
  redirectUri: string
  /**绑定的店铺ID */
  storeId?: string
  /**真实姓名 */
  realName?: string
  /**店铺名称 */
  storeName?: string
  storeCountry?: string
}
/** 绑定店铺 */
export const bindStores = async (data: IBindStoreInfo) => await http.admin.post(userUrl.bindStoresUrl, data)

export const refreshStoreInfo = async (data: { storeId: string; source: string }) => await http.admin.post(userUrl.refreshStoreInfo, data)

export interface EccangExtraInfoDTO {
  /**（约束：元素个数范围：[0,256]） */
  serviceTypeCode: string
  /**（约束：元素个数范围：[0,256]） */
  serviceToken: string
  /**（约束：元素个数范围：[0,256]） */
  appKey: string
  /**（约束：元素个数范围：[0,256]） */
  secretKey: string
  /**（约束：元素个数范围：[0,256]） */
  serviceId: string
  /**（约束：元素个数范围：[0,256]） */
  providerCode: string
  /**（约束：元素个数范围：[1,50]） */
  warehouseIds: string[]
}

interface PlatformExtraInfoDTO {
  eccang?: EccangExtraInfoDTO
}

export interface ErpBindReqDTO {
  /**店铺来源
Shopline */
  source: string
  /**编辑必填 */
  storeInfoId?: string
  /**易仓绑定信息 */
  extraInfo?: PlatformExtraInfoDTO
}

/**
 * **接口** [添加erp绑定配置信息↗](https://apidoc.inshopline.com/#/project/Java/80/feature%2F20231228_3465_eccang/interface/3b34baee7ab0295768820874abc96974)
 * @请求头 `POST /api/stores/bind/erp/create`
 * @更新时间 `2024-01-05 11:33:26`
 */
export function postErpCreate(data?: ErpBindReqDTO) {
  return http.admin.post(`/api/stores/bind/erp/create`, data)
}

/**
 * **接口** [修改erp绑定配置信息↗](https://apidoc.inshopline.com/#/project/Java/80/feature%2F20231228_3465_eccang/interface/d9c16a144c39c93be5d6e9da3833e826)
 * @请求头 `POST /api/stores/bind/erp/update`
 * @更新时间 `2024-01-05 11:33:26`
 */
export function postErpUpdate(data?: ErpBindReqDTO) {
  return http.admin.post(`/api/stores/bind/erp/update`, data)
}

interface EccangWarehouseListReqDTO {
  /**（约束：元素个数范围：[0,256]） */
  appKey: string
  /**（约束：元素个数范围：[0,256]） */
  secretKey: string
  /**（约束：元素个数范围：[0,256]） */
  serviceId: string
}

interface WarehouseInfo {
  warehouseId?: string
  warehouseStatus?: string
  warehouseCode?: string
  warehouseName?: string
}

interface WarehouseListRes {
  warehouseInfoList?: WarehouseInfo[]
}

/**
 * **接口** [查询易仓仓库列表接口↗](https://apidoc.inshopline.com/#/project/Java/80/feature%2F20231228_3465_eccang/interface/a995fd8076ded01758de10b4cf4d2cf1)
 * @请求头 `POST /api/platform/eccang/warehouse-list`
 * @更新时间 `2024-01-05 14:25:46`
 */
export function postWarehouseList(data?: EccangWarehouseListReqDTO) {
  return http.admin.post<WarehouseListRes>(`/api/platform/eccang/warehouse-list`, data)
}
